import { createEntitiesReducer } from 'app/lib/betting/betting-entities';

import { fetchSearchedValue, RESET_SEARCHED_VALUE } from '../actions';

export const reduceGrid = createEntitiesReducer({
  REQUEST_ACTION: fetchSearchedValue.pending.toString(),
  TRIGGER_ACTION: fetchSearchedValue.fulfilled.toString(),
  FAILURE_ACTION: fetchSearchedValue.rejected.toString(),
  CLEANUP_ACTION: RESET_SEARCHED_VALUE,
});
